import type { TOC } from '@ember/component/template-only';

import BillingOverviewComponent from 'webapp/components/billing/overview';

const SettingsBillingIndexRouteTemplate: TOC<object> = <template>
	<div id="billing">
		<BillingOverviewComponent />
	</div>
</template>;

export default SettingsBillingIndexRouteTemplate;
